// Mock data pour Cocoonut Digital - Version Bilingue FR/EN

export const heroSlides = [
  {
    id: 1,
    title: "Papa Lisa",
    description: { fr: "Restaurant italien — Strasbourg", en: "Italian restaurant — Strasbourg" },
    categories: ["Social Media", "Content Creation"],
    bgColor: "#1a3a52",
    textColor: "#f5e6d3",
    type: "image",
    image: "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/9ov16xm3_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM%20%282%29.jpeg"
  },
  {
    id: 2,
    title: "Casa Julia",
    description: { fr: "Restaurant & lieu événementiel — Eschau", en: "Restaurant & event venue — Eschau" },
    categories: ["Social Media", "Photography"],
    bgColor: "#4a5d6c",
    textColor: "#ffffff",
    type: "image",
    image: "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/haax4pxn_WhatsApp%20Image%202026-02-12%20at%201.33.16%20PM.jpeg"
  },
  {
    id: 3,
    title: "Hôtel Hannong",
    description: { fr: "Hôtel 4★ — Strasbourg", en: "4★ Hotel — Strasbourg" },
    categories: ["Social Media", "Content Creation"],
    bgColor: "#2d4a5c",
    textColor: "#e8d5c4",
    type: "image",
    image: "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/kweod9kp_WhatsApp%20Image%202026-02-12%20at%201.58.22%20PM.jpeg"
  }
];

export const portfolioProjects = [
  {
    id: 1,
    title: "Papa Lisa",
    description: { fr: "Restaurant italien — Strasbourg", en: "Italian restaurant — Strasbourg" },
    collaboration: { fr: "Collaboration depuis 2024", en: "Collaboration since 2024" },
    bgColor: "#f5e6d3",
    textColor: "#151515",
    type: "slideshow",
    images: [
      "https://customer-assets.emergentagent.com/job_443e5cd9-0859-4f8c-8a33-771cb593518a/artifacts/uxu20ptm_WhatsApp%20Image%202026-02-22%20at%202.05.16%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/mgiqugq2_WhatsApp%20Image%202026-03-12%20at%202.41.39%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/9ov16xm3_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/z7lioimu_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/25tj46wn_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM.jpeg"
    ],
    image: "https://customer-assets.emergentagent.com/job_443e5cd9-0859-4f8c-8a33-771cb593518a/artifacts/uxu20ptm_WhatsApp%20Image%202026-02-22%20at%202.05.16%20PM.jpeg",
    gridImage: "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/l7nu82o1_Capture%20d%27%C3%A9cran%202026-01-22%20125511.png",
    gridImageBefore: "https://customer-assets.emergentagent.com/job_a562c003-6d81-4538-9bfd-e3c510067f0b/artifacts/pfm0smhn_Capture%20d%27%C3%A9cran%202025-07-22%20162115.png",
    gridIntro: {
      fr: "Aujourd'hui, beaucoup de restaurants se contentent de publier leurs plats.\n\nMais les réseaux sociaux ne servent pas uniquement à montrer un menu.\nIls doivent raconter une ambiance, une identité, et donner envie de vivre l'expérience.",
      en: "Today, many restaurants simply post pictures of their dishes.\n\nBut social media isn't just about showcasing a menu.\nIt should tell a story — of atmosphere, identity — and make people want to live the experience."
    },
    photos: [
      "https://customer-assets.emergentagent.com/job_443e5cd9-0859-4f8c-8a33-771cb593518a/artifacts/uxu20ptm_WhatsApp%20Image%202026-02-22%20at%202.05.16%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/mgiqugq2_WhatsApp%20Image%202026-03-12%20at%202.41.39%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/9ov16xm3_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM%20%282%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/z7lioimu_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/25tj46wn_WhatsApp%20Image%202026-03-12%20at%202.47.41%20PM.jpeg"
    ],
    imageAlt: "Shooting photo restaurant Papa Lisa Strasbourg - création contenu Instagram pizzas artisanales",
    instagramCta: {
      fr: "Envie de voir plus ? Suivez @restaurantpapalisa sur Instagram pour encore plus de saveurs.",
      en: "Hungry for more? Follow @restaurantpapalisa on Instagram for even more flavours.",
      url: "https://www.instagram.com/restaurantpapalisa/"
    },
    context: {
      fr: "Restaurant italien à Strasbourg avec une présence digitale existante mais peu structurée.",
      en: "Italian restaurant in Strasbourg with an existing but poorly structured digital presence."
    },
    challenge: {
      fr: "Manque de cohérence visuelle, absence de stratégie éditoriale, contenus centrés uniquement sur les plats. Peu d'humain, peu d'émotion.",
      en: "Lack of visual consistency, no editorial strategy, content focused only on dishes. Little human touch, little emotion."
    },
    approach: {
      fr: "Mise en place d'une stratégie social media complète : refonte de la grille Instagram, création d'une ligne éditoriale claire, diversification des contenus, mise en avant des équipes et des expériences clients. Shooting photo, collaboration influenceurs, suivi KPI.",
      en: "Implementation of a complete social media strategy: Instagram grid redesign, clear editorial line, content diversification, highlighting the team and client experiences. Photo shoots, influencer collaborations, KPI monitoring."
    },
    result: {
      fr: "Image plus premium et cohérente. Positionnement clarifié. Confiance renforcée. Communauté plus engagée. Présence digitale vivante et incarnée.",
      en: "More premium and consistent image. Clarified positioning. Strengthened trust. More engaged community. Living and embodied digital presence."
    },
    services: ["Social media management", "Stratégie éditoriale", "Création de contenu photo & vidéo", "Collaboration influenceurs"]
  },
  {
    id: 2,
    title: "Hôtel Hannong",
    description: { fr: "Hôtel 4★ — Strasbourg", en: "4★ Hotel — Strasbourg" },
    collaboration: { fr: "Mission ponctuelle — 6 mois", en: "One-off mission — 6 months" },
    bgColor: "#d4a574",
    textColor: "#ffffff",
    type: "slideshow",
    images: [
      "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/kweod9kp_WhatsApp%20Image%202026-02-12%20at%201.58.22%20PM.jpeg"
    ],
    image: "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/kweod9kp_WhatsApp%20Image%202026-02-12%20at%201.58.22%20PM.jpeg",
    gridImage: "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/v3xqfrhv_Capture%20d%27%C3%A9cran%202025-03-14%20160236.png",
    gridImageBefore: "https://customer-assets.emergentagent.com/job_a562c003-6d81-4538-9bfd-e3c510067f0b/artifacts/semmwypy_Capture%20d%27%C3%A9cran%202025-01-05%20212501.png",
    gridIntro: {
      fr: "Un hôtel ne vend pas seulement des chambres, mais une expérience.\n\nL'objectif était de dépasser la simple présentation des espaces pour traduire l'atmosphère du lieu à travers le contenu.\n\nGrâce à une stratégie mêlant visuels, storytelling et moments vécus, le compte Instagram est devenu une véritable vitrine de l'expérience client.",
      en: "A hotel doesn't just sell rooms — it sells an experience.\n\nThe goal was to go beyond simply showcasing the spaces, and instead convey the atmosphere of the venue through content.\n\nWith a strategy blending visuals, storytelling and lived moments, the Instagram account became a true showcase of the guest experience."
    },
    photos: [
      "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/kweod9kp_WhatsApp%20Image%202026-02-12%20at%201.58.22%20PM.jpeg"
    ],
    imageAlt: "Photographie hôtel Hannong Strasbourg - contenu lifestyle réseaux sociaux hôtellerie",
    photoCredit: {
      fr: "La plupart des photos ont été réalisées par le photographe partenaire de l'hôtel. Les vidéos et séries de contenus ont été créées par Cocoonut Digital.",
      en: "Most photos were taken by the hotel's partner photographer. Video series and content were created by Cocoonut Digital."
    },
    context: {
      fr: "Hôtel 4 étoiles avec une identité existante forte, mais un manque de ressources internes pour gérer les réseaux sociaux.",
      en: "4-star hotel with a strong existing identity, but a lack of internal resources to manage social media."
    },
    challenge: {
      fr: "Manque de personnel dédié, besoin d'animation régulière, manque de cohérence esthétique sur Instagram.",
      en: "Lack of dedicated staff, need for regular content, lack of aesthetic consistency on Instagram."
    },
    approach: {
      fr: "Création d'une grille Instagram harmonieuse et lifestyle. Production de contenus photo & vidéo. Mise en avant de l'expérience client. Campagnes saisonnières (Saint-Valentin, événements). Animation engageante.",
      en: "Creation of a harmonious lifestyle Instagram grid. Photo & video content production. Highlighting the client experience. Seasonal campaigns (Valentine's Day, events). Engaging community management."
    },
    result: {
      fr: "Grille Instagram plus esthétique et cohérente. Image lifestyle renforcée. Communauté plus active. Meilleure valorisation de l'expérience hôtel.",
      en: "More aesthetic and consistent Instagram grid. Strengthened lifestyle image. More active community. Better showcasing of the hotel experience."
    },
    services: ["Social media management", "Création de contenu photo & vidéo", "Campagnes saisonnières"]
  },
  {
    id: 3,
    title: "Casa Julia",
    description: { fr: "Restaurant & lieu événementiel — Eschau", en: "Restaurant & event venue — Eschau" },
    collaboration: { fr: "Collaboration en pause", en: "Collaboration paused" },
    bgColor: "#e8d5c4",
    textColor: "#1a3a52",
    type: "slideshow",
    images: [
      "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/haax4pxn_WhatsApp%20Image%202026-02-12%20at%201.33.16%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_443e5cd9-0859-4f8c-8a33-771cb593518a/artifacts/ow74jfj2_WhatsApp%20Image%202026-02-22%20at%202.05.16%20PM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/461m7i9z_WhatsApp%20Image%202026-03-12%20at%202.56.46%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/2t005f2h_WhatsApp%20Image%202026-03-12%20at%202.56.45%20PM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/ijm75s5q_WhatsApp%20Image%202026-03-12%20at%202.56.45%20PM.jpeg"
    ],
    image: "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/haax4pxn_WhatsApp%20Image%202026-02-12%20at%201.33.16%20PM.jpeg",
    photos: [
      "https://customer-assets.emergentagent.com/job_cocoonut-lab/artifacts/haax4pxn_WhatsApp%20Image%202026-02-12%20at%201.33.16%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_443e5cd9-0859-4f8c-8a33-771cb593518a/artifacts/ow74jfj2_WhatsApp%20Image%202026-02-22%20at%202.05.16%20PM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/461m7i9z_WhatsApp%20Image%202026-03-12%20at%202.56.46%20PM.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/2t005f2h_WhatsApp%20Image%202026-03-12%20at%202.56.45%20PM%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_7c59b6f5-f1ab-43dc-91f7-73a40a089846/artifacts/ijm75s5q_WhatsApp%20Image%202026-03-12%20at%202.56.45%20PM.jpeg"
    ],
    imageAlt: "Création contenu restaurant Casa Julia Eschau - photographie gastronomique lieu événementiel Strasbourg",
    context: {
      fr: "Nouvelle entreprise en phase de lancement, avec un budget limité.",
      en: "New business in launch phase, with a limited budget."
    },
    challenge: {
      fr: "Construire une présence digitale dès le départ, poser des bases stratégiques, développer la notoriété progressivement.",
      en: "Build a digital presence from scratch, lay strategic foundations, progressively develop brand awareness."
    },
    approach: {
      fr: "Social media management adapté au budget. Création de contenus photo & vidéo. Mise en place d'une cohérence visuelle. Positionnement progressif avec rythme ajusté.",
      en: "Budget-adapted social media management. Photo & video content creation. Building visual consistency. Progressive positioning with adjusted pace."
    },
    result: {
      fr: "Présence digitale professionnelle dès le lancement. Image cohérente. Bases stratégiques solides. Croissance progressive et maîtrisée.",
      en: "Professional digital presence from launch. Consistent image. Solid strategic foundations. Progressive and controlled growth."
    },
    services: ["Social media management", "Création de contenu photo & vidéo", "Stratégie de lancement"]
  }
];

export const services = {
  fr: [
    {
      id: 1, title: "Social Media Management",
      description: "Nous animons votre présence digitale avec stratégie et sensibilité. De la planification éditoriale à la publication, chaque contenu traduit l'atmosphère de votre établissement et l'expérience que vous offrez à table.",
      icon: "Users", image: "https://images.unsplash.com/photo-1726066012749-f81bf4422d4e"
    },
    {
      id: 2, title: "Content Creation",
      description: "Photo & vidéo pensées pour révéler les saveurs, les textures et l'univers culinaire de votre lieu. Chaque image capture l'âme de votre table et donne envie de pousser la porte.",
      icon: "Camera", image: "https://images.unsplash.com/photo-1532272278764-53cd1fe53f72"
    },
    {
      id: 3, title: "Visual Storytelling",
      description: "Nous transformons l'identité de votre établissement en récit visuel authentique. De l'atmosphère en salle aux recettes en cuisine, chaque histoire crée une connexion émotionnelle avec votre audience.",
      icon: "Film", image: "https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf"
    },
    {
      id: 4, title: "Stratégie Digitale",
      description: "Direction artistique et stratégie de contenu sur mesure pour votre lieu de vie. Nous créons des expériences digitales cohérentes qui reflètent l'atmosphère et le savoir-faire de votre établissement.",
      icon: "Sparkles", image: "https://images.pexels.com/photos/8357676/pexels-photo-8357676.jpeg"
    }
  ],
  en: [
    {
      id: 1, title: "Social Media Management",
      description: "We bring your digital presence to life with strategy and sensitivity. From editorial planning to publishing, every piece of content conveys the atmosphere of your venue and the experience you offer at the table.",
      icon: "Users", image: "https://images.unsplash.com/photo-1726066012749-f81bf4422d4e"
    },
    {
      id: 2, title: "Content Creation",
      description: "Photo & video crafted to reveal the flavours, textures and culinary universe of your venue. Every image captures the soul of your table and makes people want to walk through the door.",
      icon: "Camera", image: "https://images.unsplash.com/photo-1532272278764-53cd1fe53f72"
    },
    {
      id: 3, title: "Visual Storytelling",
      description: "We transform your venue's identity into an authentic visual narrative. From the dining room atmosphere to the recipes in the kitchen, every story creates an emotional connection with your audience.",
      icon: "Film", image: "https://images.unsplash.com/photo-1611784728558-6c7d9b409cdf"
    },
    {
      id: 4, title: "Digital Strategy",
      description: "Art direction and tailor-made content strategy for your hospitality venue. We create cohesive digital experiences that reflect the atmosphere and expertise of your establishment.",
      icon: "Sparkles", image: "https://images.pexels.com/photos/8357676/pexels-photo-8357676.jpeg"
    }
  ]
};

export const testimonials = {
  fr: [
    {
      id: 1, name: "Nicolas Gruet", role: "Gérant – Papa Lisa, Strasbourg",
      text: "Depuis que Rham s'occupe de notre communication, nous voyons une vraie différence. Les contenus sont de qualité et mettent vraiment notre restaurant en valeur. Elle est très impliquée et toujours prête à se dépasser pour faire avancer les choses. Nous sommes très contents de l'avoir à nos côtés.",
      avatar: ""
    },
    {
      id: 2, name: "JC Colnel", role: "Gérant / Chef – Casa Julia, Eschau",
      text: "Rham nous accompagne pour la communication de Casa Julia et nous sommes très contents de cette collaboration. Elle est très impliquée et crée des photos et vidéos qui mettent vraiment nos plats et l'ambiance du restaurant en valeur. Elle est aussi très flexible et comprend bien la réalité financière d'un restaurant.",
      avatar: ""
    }
  ],
  en: [
    {
      id: 1, name: "Nicolas Gruet", role: "Owner – Papa Lisa, Strasbourg",
      text: "Since Rham took over our communication, we've seen a real difference. The content is high quality and truly showcases the restaurant. She is very dedicated and always ready to go above and beyond to move things forward. We are very happy to have her by our side.",
      avatar: ""
    },
    {
      id: 2, name: "JC Colnel", role: "Owner / Chef – Casa Julia, Eschau",
      text: "Rham supports us with Casa Julia's communication and we are very happy with this collaboration. She is very dedicated and creates photos and videos that truly highlight our dishes and the restaurant's atmosphere. She is also very flexible and understands the financial reality of a restaurant.",
      avatar: ""
    }
  ]
};

export const workProcess = {
  fr: [
    { id: 1, step: "01", title: "Écoute & Immersion", description: "Nous prenons le temps de comprendre votre univers, vos valeurs et votre vision. Chaque collaboration commence par une vraie rencontre." },
    { id: 2, step: "02", title: "Stratégie & Direction Créative", description: "Ensemble, nous définissons une stratégie de contenu alignée avec vos objectifs. Direction artistique, ton, esthétique : tout est pensé pour vous." },
    { id: 3, step: "03", title: "Création de Contenu", description: "Production photo & vidéo sur mesure. Nous créons des contenus qui racontent votre histoire avec authenticité." },
    { id: 4, step: "04", title: "Déploiement & Suivi", description: "Publication stratégique et gestion continue. Nous analysons, optimisons et faisons évoluer votre présence en temps réel." }
  ],
  en: [
    { id: 1, step: "01", title: "Listening & Immersion", description: "We take the time to understand your world, your values and your vision. Every collaboration starts with a genuine meeting." },
    { id: 2, step: "02", title: "Strategy & Creative Direction", description: "Together, we define a content strategy aligned with your goals. Art direction, tone, aesthetic: everything is designed for you." },
    { id: 3, step: "03", title: "Content Creation", description: "Tailor-made photo & video production. We create content that tells your story with authenticity." },
    { id: 4, step: "04", title: "Deployment & Monitoring", description: "Strategic publishing and ongoing management. We analyse, optimise and evolve your presence in real time." }
  ]
};
